// packages import
import { FC, useContext } from 'react'
import { Box, Typography } from '@mui/material'

// component imports
import InterestEntriesFilters from '../../../components/billing/interestEntries/filters'
import { InterestEntriesListing } from '../../../components/billing/interestEntries/InterestEntriesListing'
import { EmptyData } from '../../../components/common/EmptyData'

// others
import { InterestEntriesContext } from '../../../context/InterestEntriesContext'
import { CardBox, CardHeader } from '../../../theme/styleComponents'
import { flexCenter } from '../../../theme/styleConstants'

const InterestEntries: FC = (): JSX.Element => {
  const { interestEntries, loading } = useContext(InterestEntriesContext)
  const isEmpty = interestEntries?.length === 0 && !loading

  return (
    <CardBox marginTop={3}>
      <CardHeader direction="column" sx={{ p: 2, gap: 1, alignItems: 'flex-start' }}>
        <Typography variant="body1" fontSize="24px">
          Interest Entries
        </Typography>

        <Box sx={{ color: 'text.secondary', fontSize: '13px', lineHeight: 1.6 }}>
          <Typography variant="inherit" gutterBottom>
            Interest is calculated <strong>daily</strong> for each bill once its <strong>due date</strong> has passed.
            Each row represents one day's interest charge for a specific bill and client.
          </Typography>
          <Typography variant="inherit" gutterBottom>
            <strong>Deleting from a date</strong> (e.g. <strong>April 15</strong>) removes that entry and{' '}
            <strong>all later entries</strong> for that bill and client. The system will recalculate them on the next
            daily run — to prevent recalculation:
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            <Typography component="li" variant="inherit">
              Enable <strong>"Don't charge interest on this matter"</strong> checkbox in Matter Billing Settings (Matter
              Detail → Edit button), or
            </Typography>
            <Typography component="li" variant="inherit">
              Check <strong>"Don't charge interest on this matter"</strong> checkbox while deleting entries.
            </Typography>
          </Box>
          <Typography variant="inherit" gutterBottom>
            Further, the delete button is disabled for partially paid, paid, pre-paid, or written-off bills. You cannot delete entries for these bills. Instead of deleting, you can write off the interest for these bill.
          </Typography>
        </Box>
      </CardHeader>

      <InterestEntriesFilters />

      {isEmpty ? (
        <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
          <EmptyData title="No interest entries found" />
        </Box>
      ) : (
        <InterestEntriesListing />
      )}
    </CardBox>
  )
}

export default InterestEntries
